<!-- plan Section Start -->
<div class="el-breadcrumb-wrapper">
    <div class="container">
        <div class="el-breadcrmb-inner">
            <h1> Products</h1>
            <ul>

                <li> <a [routerLink]="['/dashboard']" style="color: #e04787;"><i class="fa fa-reply "
                            aria-hidden="true"></i> Back</a></li>
            </ul>
        </div>
    </div>
</div>
<app-plans></app-plans>

<app-buy-book></app-buy-book>
<!-- plan Section End -->